function setCookie(cname, cvalue, exdays) {
	let expires = "";

	if (exdays) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		expires = `; expires=${d.toUTCString()}`;
	}

	document.cookie = `${cname}=${cvalue}${expires};path=/`;
}

function getCookie(cname) {
	const name = `${cname}=`;
	const ca = document.cookie.split(";");
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == " ") {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

function deleteCookie(cname) {
	setCookie(cname, "", -1);
}

//********************
// Web Storage
//********************
// Use cookies, when Storage doesn't work (i.E. Safari in private mode)

let useStorageAPI = true;
if (typeof localStorage === "object") {
	try {
		localStorage.setItem("storageAPI", "true");
		localStorage.removeItem("storageAPI");
	} catch (e) {
		useStorageAPI = false;
	}
} else {
	useStorageAPI = false;
}

/**
 * @param {string} key
 * @param {string} content
 * @returns {string}
 */
const setLocalStorage = function (key, content) {
	if (useStorageAPI) {
		localStorage.setItem(key, content);
	} else {
		setCookie(`local_${key}`, content, 365);
	}
	return `${key}:${content}`;
};

/**
 * @param {string} key
 * @returns {string | null}
 */
const getLocalStorage = function (key) {
	if (useStorageAPI) return localStorage.getItem(key);
	return getCookie(`local_${key}`);
};

/**
 * @param {string} key
 * @param {string} content
 * @returns {string}
 */
const setSessionStorage = function (key, content) {
	if (useStorageAPI) {
		sessionStorage.setItem(key, content);
	} else {
		setCookie(`session_${key}`, content);
	}
	return `${key}:${content}`;
};

/**
 * @param {string} key
 * @returns {string | null}
 */
const getSessionStorage = function (key) {
	if (useStorageAPI) return sessionStorage.getItem(key);
	return getCookie(`session_${key}`);
};

export { setCookie, getCookie, deleteCookie, setLocalStorage, getLocalStorage, setSessionStorage, getSessionStorage };
